import keycloak from "../keycloak";
import { EventSourcePolyfill } from 'event-source-polyfill';

export const subscribeTo = (url, onSuccess = (message = '') => {}, onError = (message) => {}, onUpdate = (result) => {}) => {
  const es = new EventSourcePolyfill(process.env.REACT_APP_MERCURE_PUBLIC_URL + '?topic=' + url, {
    headers: {
      Authorization: `Bearer ${keycloak.token}`,
    }
  })

  const onMessage = async (event) => {
    try {
      const result = JSON.parse(event.data);
      console.log('eventSource.onmessage', result)

      if (result && result.state === 'success') {
        if (typeof onSuccess === 'function') {
          onSuccess(result.message)
        }
      }

      if (result && result.state === 'error') {
        if (typeof onError === 'function') {
          onError(result.message)
        }
      }

      onUpdate(result)
    } catch (e) {
    }
  }

  const errorListener = () => {
    if (typeof onError === 'function') {
      onError()
    }
  }

  es.addEventListener("message", onMessage);
  es.addEventListener("error", errorListener);

  return es
}
